import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";

type PublicBasedRefundProtectionConfigurationSerializer = {
  public_key: string;
};

export default class PublicBasedRefundProtectionConfigurationRepository extends Repository<PublicBasedRefundProtectionConfigurationSerializer> {
  public readonly repositoryName =
    "PublicBasedRefundProtectionConfigurationRepository";

  public readonly endpoint = "api/public/refund-protection/";
  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      config: "config",
    };
  }
}
